import React from 'react';
import Route from '../Route';
import GeckoLocation from 'services/gecko-location';
import Conversations from './Conversations.jsx';

const routes = new Route({
  path: '/results',
  children: [
    {
      name: 'Search Results - Conversations',
      path: '/conversations',
      action: async () => <Conversations />,
    },
    {
      name: 'Search Results',
      path: '/',
      action: () => {
        GeckoLocation.goTo('/results/conversations', GeckoLocation.params);
        return null;
      },
    },
  ],
});

export default routes;
